// @flow

export const ATTACH = 'ATTACH_TO_REQUEST_POPUP/REQUEST_CREATE'
export const MOVE = 'ATTACH_TO_REQUEST_POPUP/MOVE_THREAD'
export const MOVED = 'ATTACH_TO_REQUEST_POPUP/REQUEST_MOVED'
export const CLEAN_ATTACHED = 'ATTACH_TO_REQUEST_POPUP/CLEAN_ATTACHED'
export const ATTACHED = 'ATTACH_TO_REQUEST_POPUP/REQUEST_CREATED'
export const ERROR = 'ATTACH_TO_REQUEST_POPUP/ERROR'
export const INIT = 'ATTACH_TO_REQUEST_POPUP/INIT'
